import { render, staticRenderFns } from "./HealthFacilities.vue?vue&type=template&id=0c89eabd&scoped=true&"
import script from "./HealthFacilities.vue?vue&type=script&lang=js&"
export * from "./HealthFacilities.vue?vue&type=script&lang=js&"
import style0 from "./HealthFacilities.vue?vue&type=style&index=0&id=0c89eabd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c89eabd",
  null
  
)

export default component.exports